import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import CreateAssessment from "./CreateAssessment";
import { Grid, Button, Typography, Tooltip } from "@mui/material";
import ButtonGroup from "@mui/material/ButtonGroup";
import axios from "../../libs/axios";
import "../Assesment/styles.css";
import VisibilityIcon from "@material-ui/icons/Visibility";
// import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../../screens/store/actions/authActions";
import EditIcon from "@material-ui/icons/Edit";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import GetAppIcon from "@material-ui/icons/GetApp";
import DescriptionIcon from "@material-ui/icons/Description";
import CircularProgress from "@mui/material/CircularProgress";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import DeletePopup from "../AssessmentsTable/DeletePopup";
import ReAssessmentConfirmPopup from "../AssessmentsTable/ReAssessmentConfirmPopup";
import prsdark from "../../assets/img/Dark_logomark.png";
import olldark from "../../assets/img/Logomark_W.png";
// import PdfComplete from "../Stepper7/PdfComplete";

const columns = [
  { id: "id", label: "Assessment Id", minWidth: 100 },
  { id: "company_name", label: "Name", minWidth: 100 },
  {
    id: "contact_name",
    label: "Contact Name",
    minWidth: 100,
  },
  {
    id: "company_contact_email",
    label: "Contact Email",
    minWidth: 100,
  },
  // {
  //   id: "company_contact_number",
  //   label: "Contact Number",
  //   minWidth: 100,
  // },
  {
    id: "status",
    label: "Status",
    minWidth: 100,
  },
  { id: "view", label: "Action", minWidth: 220 },
];

const useStyles = makeStyles({
  root: {
    width: "100%",
    padding: "1rem 1rem 0 1rem",
  },
  container: {
    maxHeight: 600,
  },
});

export default function AssessmentsTable() {
  const classes = useStyles();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [rows, setRows] = useState([]);
  const [callingBackend, setCallingBackend] = useState(false);
  const [snackalert, setSnackalert] = useState(false);
  const [reAssessment, setReAssessment] = useState(true);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  let navigate = useNavigate();

  let dispatch = useDispatch();

  const accessToken = sessionStorage.getItem("accessToken");
  if (!accessToken) {
    navigate("/");
  }
  const onLogout = () => {
    dispatch(logout());
    navigate("/");
  };
  const loadData = async (reAsses) => {
    try {
      setCallingBackend(true);
      if (reAsses) {
        const { data } = await axios.get("/assesment/list");
        setRows(data);
      } else {
        const { data } = await axios.get("/assesment/reassessment");
        setRows(data);
      }
    } catch (error) {
      console.error("Error loading data", error);
    } finally {
      setCallingBackend(false);
    }
  };

  const handleReAssesment = async () => {
    try {
      setReAssessment(false);
      loadData(false);
    } catch (error) {
      console.error(error);
    }
  };
  const handleAssesment = async () => {
    try {
      setReAssessment(true);
      loadData(true);
    } catch (error) {
      console.error(error);
    }
  };

  const onUpdate = (id) => {
    navigate("/assessment", { state: { id } });
  };

  const onComplete = (id) => {
    navigate("/complete", { state: { id } });
  };

  useEffect(() => {
    loadData(reAssessment);
  }, []);

  return (
    <Grid
      container
      sx={{
        height: "100vh",
        justifyContent: "center",
        alignContent: "flex-start",
      }}
    >
      <Grid
        container
        item
        className="mainscreenview"
        sx={{
          height: "100vh",
          position: "absolute",
          zIndex: -1,
        }}
      >
        {" "}
      </Grid>

      <Grid
        container
        item
        xs={10}
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          marginTop: "2rem",
          zIndex: 15,
        }}
      >
        <Typography
          sx={{ fontSize: "2rem", color: "#22345B", fontWeight: 700 }}
        >
          {reAssessment ? "Assessments View" : "Re-Assessments View"}{" "}
        </Typography>
        <Grid
          container
          item
          xs={4}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignContent: "center",
          }}
        >
          <CreateAssessment
            loadData={() => {
              loadData(true);
              setReAssessment(true);
            }}
          />
          <Button
            onClick={() => onLogout()}
            sx={{
              backgroundColor: "#22345B",
              textTransform: "capitalize",
              fontFamily: "serif",
              color: "#ffffff",
              borderRadius: "8px",
              marginLeft: "1rem",
              ":hover": { backgroundColor: "#22345B" },
            }}
          >
            Logout
          </Button>
        </Grid>
      </Grid>
      <Grid
        container
        item
        xs={10}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignContent: "flex-start",
          marginTop: "2rem",
          zIndex: 15,
        }}
      >
        <ButtonGroup
          disableElevation
          variant="contained"
          aria-label="Disabled button group"
        >
          <Button
            onClick={() => handleAssesment()}
            sx={{
              backgroundColor: reAssessment
                ? "rgba(22, 10, 77, 0.33)"
                : "transparent",
              color: "#000",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "rgba(22, 10, 77, 0.33)",
                boxShadow: "none",
              },
            }}
          >
            Assessments
          </Button>
          <Button
            onClick={() => handleReAssesment()}
            sx={{
              backgroundColor: reAssessment
                ? "transparent"
                : "rgba(22, 10, 77, 0.33)",
              color: "#000",
              textTransform: "none",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "rgba(22, 10, 77, 0.33)",
                boxShadow: "none",
              },
            }}
          >
            Re-Assessments
          </Button>
        </ButtonGroup>
      </Grid>
      {callingBackend ? (
        <Grid
          container
          item
          xs={10}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            margin: "2rem 0",
            zIndex: 15,
            height: "70vh",
          }}
        >
          <CircularProgress size={50} sx={{ color: "#22345B" }} />
        </Grid>
      ) : (
        <div
          style={{
            height: "90vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
          }}
        >
          <Grid
            container
            item
            xs={10}
            sx={{
              display: "flex",
              justifyContent: "start",
              margin: "2rem 0",
              zIndex: 15,
              height: "fit-content",
            }}
          >
            <Paper className={classes.root}>
              <TableContainer className={classes.container}>
                <Table stickyHeader aria-label="sticky table">
                  <TableHead>
                    <TableRow>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align || "left"}
                          style={{
                            minWidth: column.minWidth,
                            fontSize: "1rem",
                            fontWeight: 700,
                            color: "#22345B",
                          }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {reAssessment ? (
                    <TableBody>
                      {rows
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                          >
                            <TableCell key="id">{row?.assessmentId}</TableCell>
                            <TableCell key="company_name">
                              {row?.assessment?.company_name?.slice(0, 20) +
                                (row?.assessment?.company_name?.length > 20
                                  ? "..."
                                  : "")}
                            </TableCell>
                            <TableCell key="contact_name">
                              {row?.assessment?.company_contact_first_name?.slice(
                                0,
                                15
                              ) + " " +
                                (row?.assessment?.company_contact_last_name
                                  ? row?.assessment?.company_contact_last_name
                                  : row?.assessment?.company_name?.length > 15
                                  ? "..."
                                  : "")}
                            </TableCell>
                            <TableCell key="company_contact_email">
                              {row?.assessment?.company_contact_email
                                ? row?.assessment?.company_contact_email
                                : row?.assessment?.company_email}
                            </TableCell>
                            <TableCell key="status">
                              {row?.status === "complete" ? (
                                <p style={{ color: "#22345B" }}>Complete</p>
                              ) : (
                                "In Progress"
                              )}
                            </TableCell>
                            <TableCell key="company_contact_last_name">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "8px",
                                }}
                              >
                                {/* Edit Button */}
                                <Tooltip title="Edit assessment">
                                  <Button
                                    onClick={() => onUpdate(row?._id)}
                                    sx={{
                                      backgroundColor: "#b19777",
                                      textTransform: "capitalize",
                                      fontFamily: "serif",
                                      borderRadius: "50%",
                                      width: "40px",
                                      height: "40px",
                                      minWidth: "40px",
                                      color: "#ffffff",
                                      ":hover": { backgroundColor: "#b19777" },
                                    }}
                                  >
                                    <EditIcon />
                                  </Button>
                                </Tooltip>

                                {/* View Button */}
                                {row?.status === "complete" ? (
                                  <Tooltip title="View assessment">
                                    <a
                                      href={row?.pdflink}
                                      download={"assessment.pdf"}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Button
                                        sx={{
                                          backgroundColor: "#b19777",
                                          textTransform: "capitalize",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                          ":hover": {
                                            backgroundColor: "#b19777",
                                          },
                                        }}
                                      >
                                        <VisibilityIcon />
                                      </Button>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="View assessment">
                                    <span style={{ display: "inline-flex" }}>
                                      <Button
                                        onClick={() => onComplete(row?._id)}
                                        disabled
                                        sx={{
                                          textTransform: "capitalize",
                                          backgroundColor: "#eee",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                        }}
                                      >
                                        <VisibilityOffIcon />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}

                                {/* Download Button */}
                                {row?.status === "complete" ? (
                                  <Tooltip title="Download PDF">
                                    <a
                                      href={row?.downloadlink}
                                      download={"assessment.pdf"}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Button
                                        sx={{
                                          backgroundColor: "#b19777",
                                          textTransform: "capitalize",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                          ":hover": {
                                            backgroundColor: "#b19777",
                                          },
                                        }}
                                      >
                                        <GetAppIcon />
                                      </Button>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Download PDF">
                                    <span style={{ display: "inline-flex" }}>
                                      <Button
                                        onClick={() => onComplete(row?._id)}
                                        disabled
                                        sx={{
                                          textTransform: "capitalize",
                                          backgroundColor: "#eee",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                        }}
                                      >
                                        <GetAppIcon />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}

                                {row?.docxdownloadlink ? (
                                  <Tooltip title="Download Word Document">
                                    <a
                                      href={row?.docxdownloadlink}
                                      download={"assessment.docx"}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Button
                                        sx={{
                                          backgroundColor: "#b19777",
                                          textTransform: "capitalize",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                          ":hover": {
                                            backgroundColor: "#b19777",
                                          },
                                        }}
                                      >
                                        <DescriptionIcon />
                                      </Button>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Download Word Document">
                                    <span style={{ display: "inline-flex" }}>
                                      <Button
                                        disabled
                                        sx={{
                                          textTransform: "capitalize",
                                          backgroundColor: "#eee",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                        }}
                                      >
                                        <DescriptionIcon />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}

                                {/* Delete Button - Assuming DeletePopup renders a circular button */}
                                <DeletePopup
                                  id={row?._id}
                                  setSnackalert={setSnackalert}
                                  loadData={() => {
                                    loadData(reAssessment);
                                  }}
                                  name={row?.assessment?.company_name}
                                />
                                {row?.complete_date &&
                                  ((new Date().getTime() -
                                    new Date(row.complete_date).getTime()) /
                                    (1000 * 60 * 60 * 24) >=
                                  14 ? (
                                    <ReAssessmentConfirmPopup
                                      row={row}
                                      setReAssessment={setReAssessment}
                                      setSnackalert={setSnackalert}
                                      loadData={() => {
                                        loadData(reAssessment);
                                      }}
                                      setCallingBackend={setCallingBackend}
                                      setRows={setRows}
                                      name={row?.assessment?.company_name}
                                    />
                                  ) : (
                                    <Tooltip title="Create reassessment">
                                      <span style={{ display: "inline-flex" }}>
                                        <Button
                                          disabled
                                          sx={{
                                            textTransform: "capitalize",
                                            backgroundColor: "#eee",
                                            fontFamily: "serif",
                                            borderRadius: "50%",
                                            width: "40px",
                                            height: "40px",
                                            minWidth: "40px",
                                            color: "#ffffff",
                                          }}
                                        >
                                          <FileCopyIcon />
                                        </Button>
                                      </span>
                                    </Tooltip>
                                  ))}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  ) : (
                    <TableBody>
                      {rows
                        ?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row) => (
                          <TableRow
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            key={row.id}
                          >
                            <TableCell key="id">
                              {row?.reAssessmentId}
                            </TableCell>
                            <TableCell key="company_name">
                              {row?.assessment?.company_name?.slice(0, 20) +
                                (row?.assessment?.company_name?.length > 20
                                  ? "..."
                                  : "")}
                            </TableCell>
                            <TableCell key="contact_name">
                              {row?.assessment?.company_contact_first_name?.slice(
                                0,
                                15
                              ) +
                                (row?.assessment?.company_contact_first_name
                                  ? row?.assessment?.company_contact_first_name
                                  : row?.assessment?.company_name?.length > 15
                                  ? "..."
                                  : "")}
                            </TableCell>
                            <TableCell key="company_contact_email">
                              {row?.assessment?.company_contact_email
                                ? row?.assessment?.company_contact_email
                                : row?.assessment?.company_email}
                            </TableCell>
                            <TableCell key="status">
                              {row?.status === "complete" ? (
                                <p style={{ color: "#22345B" }}>Complete</p>
                              ) : (
                                "In Progress"
                              )}
                            </TableCell>
                            <TableCell key="company_contact_last_name">
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  gap: "8px",
                                }}
                              >
                                {/* Edit Button */}
                                <Tooltip title="Edit re-assessment">
                                  <Button
                                    onClick={() => onUpdate(row?._id)}
                                    sx={{
                                      backgroundColor: "#b19777",
                                      textTransform: "capitalize",
                                      fontFamily: "serif",
                                      borderRadius: "50%",
                                      width: "40px",
                                      height: "40px",
                                      minWidth: "40px",
                                      color: "#ffffff",
                                      ":hover": { backgroundColor: "#b19777" },
                                    }}
                                  >
                                    <EditIcon />
                                  </Button>
                                </Tooltip>

                                {/* View Button */}
                                {row?.status === "complete" ? (
                                  <Tooltip title="View re-assessment">
                                    <a
                                      href={row?.reassessmetpdflink}
                                      download={"reassessmet.pdf"}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Button
                                        sx={{
                                          backgroundColor: "#b19777",
                                          textTransform: "capitalize",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                          ":hover": {
                                            backgroundColor: "#b19777",
                                          },
                                        }}
                                      >
                                        <VisibilityIcon />
                                      </Button>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="View re-assessment">
                                    <span style={{ display: "inline-flex" }}>
                                      <Button
                                        onClick={() => onComplete(row?._id)}
                                        disabled
                                        sx={{
                                          textTransform: "capitalize",
                                          backgroundColor: "#eee",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                        }}
                                      >
                                        <VisibilityOffIcon />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}

                                {/* Download Button */}
                                {row?.status === "complete" ? (
                                  <Tooltip title="Download PDF">
                                    <a
                                      href={row?.reassessmetdownloadlink}
                                      download={"reassessment.pdf"}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Button
                                        sx={{
                                          backgroundColor: "#b19777",
                                          textTransform: "capitalize",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                          ":hover": {
                                            backgroundColor: "#b19777",
                                          },
                                        }}
                                      >
                                        <GetAppIcon />
                                      </Button>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Download PDF">
                                    <span style={{ display: "inline-flex" }}>
                                      <Button
                                        onClick={() => onComplete(row?._id)}
                                        disabled
                                        sx={{
                                          textTransform: "capitalize",
                                          backgroundColor: "#eee",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                        }}
                                      >
                                        <GetAppIcon />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}

                                {row?.reassessmetdocxdownloadlink ? (
                                  <Tooltip title="Download Word Document">
                                    <a
                                      href={row?.reassessmetdocxdownloadlink}
                                      download={"reassessment.docx"}
                                      target="_blank"
                                      rel="noreferrer noopener"
                                      style={{ display: "inline-flex" }}
                                    >
                                      <Button
                                        sx={{
                                          backgroundColor: "#b19777",
                                          textTransform: "capitalize",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                          ":hover": {
                                            backgroundColor: "#b19777",
                                          },
                                        }}
                                      >
                                        <DescriptionIcon />
                                      </Button>
                                    </a>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Download Word Document">
                                    <span style={{ display: "inline-flex" }}>
                                      <Button
                                        disabled
                                        sx={{
                                          textTransform: "capitalize",
                                          backgroundColor: "#eee",
                                          fontFamily: "serif",
                                          borderRadius: "50%",
                                          width: "40px",
                                          height: "40px",
                                          minWidth: "40px",
                                          color: "#ffffff",
                                        }}
                                      >
                                        <DescriptionIcon />
                                      </Button>
                                    </span>
                                  </Tooltip>
                                )}

                                {/* Delete Button - Assuming DeletePopup renders a circular button */}
                                <DeletePopup
                                  id={row?._id}
                                  setSnackalert={setSnackalert}
                                  loadData={() => {
                                    loadData(reAssessment);
                                  }}
                                  name={row?.assessment?.company_name}
                                  tooltipTitle="Delete re-assessment"
                                />
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  )}
                </Table>
                <Snackbar
                  open={snackalert}
                  autoHideDuration={5000}
                  onClose={!snackalert}
                >
                  <Alert
                    onClose={!snackalert}
                    severity="success"
                    variant="filled"
                    sx={{ width: "100%" }}
                  >
                    Assessment deleted successfully!
                  </Alert>
                </Snackbar>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 21, 100]} // Options for number of rows per page
                component="div"
                count={rows.length}
                rowsPerPage={rowsPerPage} // Set default to 5
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Paper>
          </Grid>
        </div>
      )}
      {!callingBackend ? (
        <Grid
          container
          xs={12}
          sx={{
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#22345B",
          }}
        >
          <Grid
            container
            xs={12}
            sx={{
              bottom: 0,
              zIndex: 100,
              padding: "8px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              item
              xs={11}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid
                container
                item
                xs={6}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={prsdark} alt="prs-logo" width="12px" />
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                    paddingLeft: "0.5rem",
                  }}
                >
                  PlacedRisk Solutions Assessment Portal
                </Typography>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                    paddingRight: "0.5rem",
                  }}
                >
                  Designed, Developed and Maintained by
                </Typography>
                <img
                  src={olldark}
                  alt="ollcode-logo"
                  width="20px"
                  height="auto"
                />
                <a
                  href="https://ollcode.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography
                    sx={{
                      color: "#ffffff",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      paddingLeft: "0.5rem",
                    }}
                  >
                    Ollcode
                  </Typography>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <Grid
          container
          xs={12}
          sx={{
            position: "fixed",
            bottom: 0,
            zIndex: 100,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#22345B",
          }}
        >
          <Grid
            container
            xs={12}
            sx={{
              bottom: 0,
              zIndex: 100,
              padding: "8px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              item
              xs={11}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Grid
                container
                item
                xs={6}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <img src={prsdark} alt="prs-logo" width="12px" />
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                    paddingLeft: "0.5rem",
                  }}
                >
                  PlacedRisk Solutions Assessment Portal
                </Typography>
              </Grid>
              <Grid
                container
                item
                xs={6}
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-end",
                  alignContent: "center",
                  alignItems: "center",
                }}
              >
                <Typography
                  sx={{
                    color: "#ffffff",
                    fontSize: "0.8rem",
                    fontWeight: 500,
                    paddingRight: "0.5rem",
                  }}
                >
                  Designed, Developed and Maintained by
                </Typography>
                <img
                  src={olldark}
                  alt="ollcode-logo"
                  width="20px"
                  height="auto"
                />
                <a
                  href="https://ollcode.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Typography
                    sx={{
                      color: "#ffffff",
                      fontSize: "0.8rem",
                      fontWeight: 600,
                      paddingLeft: "0.5rem",
                    }}
                  >
                    Ollcode
                  </Typography>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
